module.exports = __webpack_public_path__ + "static/media/czech-republic.79984b1b.png";